// extracted by mini-css-extract-plugin
module.exports = {"steps":"_3xdec","text":"_2cBhN"};